import React from 'react';

import { useTextOverlay } from '../../state/TextOverlayProvider';
import OldStylePreset from './presets/OldStylePreset';
import ResetPreset from './presets/ResetPreset';

const LocalPresetsList: React.FunctionComponent = () => {
  const { localPresets } = useTextOverlay();

  if (!localPresets.enabled) {
    return null;
  }

  const { aspectRatio } = localPresets;

  return (
    <>
      {localPresets.presets.map(preset => {
        switch (preset.type) {
          case 'old-style':
            return (
              <OldStylePreset
                key={preset.type}
                aspectRatio={aspectRatio}
                preset={preset}
              />
            );
          case 'reset':
            return (
              <ResetPreset
                key={preset.type}
                aspectRatio={aspectRatio}
                preset={preset}
              />
            );
          default:
            return null;
        }
      })}
    </>
  );
};

export default LocalPresetsList;
